// extracted by mini-css-extract-plugin
module.exports = {"radio":"styles_radio__Ctet5","reverse":"styles_reverse___GERP","title":"styles_title__pZKqQ","medium":"styles_medium__h5Cdt"};